module.exports = __webpack_public_path__ + "img/type_reefer.e82b7697.jpg";